var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8151 10.197L3.28308 11.453C3.19649 11.4675 3.11522 11.5045 3.04746 11.5603C2.97971 11.6161 2.92784 11.6888 2.89708 11.771L0.30008 18.728C0.0520799 19.368 0.72108 19.978 1.33508 19.671L19.3351 10.671C19.4598 10.6088 19.5646 10.513 19.6379 10.3945C19.7112 10.276 19.75 10.1394 19.75 10C19.75 9.86067 19.7112 9.72407 19.6379 9.60555C19.5646 9.48703 19.4598 9.39128 19.3351 9.32902L1.33508 0.329023C0.72108 0.0220227 0.0520799 0.633023 0.30008 1.27202L2.89808 8.22902C2.92869 8.31144 2.9805 8.38432 3.04827 8.44033C3.11604 8.49633 3.19737 8.53348 3.28408 8.54802L10.8161 9.80302C10.8624 9.81114 10.9044 9.83535 10.9347 9.87138C10.965 9.90741 10.9816 9.95296 10.9816 10C10.9816 10.0471 10.965 10.0926 10.9347 10.1287C10.9044 10.1647 10.8624 10.1889 10.8161 10.197H10.8151Z",
    fill: "#C0C0C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSend);
export default __webpack_public_path__ + "static/media/chat-send.8c14674a0d3142f00105440395ba7226.svg";
export { ForwardRef as ReactComponent };